<template>
    <div class="white-rounded-box pl-7 pt-5 mb-2">
        <div class="flex-col justify-between items-center mr-9 mb-5">
            <h1>Contact Hours</h1>
            <div class="mt-4">
                <button
                    :disabled="isSaveButtonDisabled"
                    type="button"
                    @click="submitHours"
                    class="flex mx-auto -mt-11 pl-5 text-white storefront-btn-blue font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                    <svg-vue
                        v-if="isSavingHoursInfo"
                        icon="loader"
                        title="Loading"
                    />
                    Save
                </button>
            </div>
        </div>
        <div>
            <ContactHoursTable
                :hoursType="'personal'"
                v-on:changed="updatedPersonalHours"
                :user="user"
            />
        </div>
    </div>
</template>

<script>
import Hours from "../../Storefront/partials/Hours.vue";
import ContactHoursTable from "./ContactHoursTable.vue";
export default {
    props: ["user"],
    data() {
        return {
            search: "",
            hoursModalVisible: false,
            contactHoursModalVisible: false,
            notifications: "",
            isSavingHoursInfo: false,
            personalHoursArray: [],
        };
    },
    methods: {
        async onSearch() {
            // TODO: implement searching through pinned posts
        },
        onHoursModalHidden() {
            this.hoursModalVisible = false;
        },
        onHoursModalViewable() {
            this.hoursModalVisible = true;
        },
        onContactHoursModalHidden() {
            this.contactHoursModalVisible = false;
        },
        onContactHoursModalViewable() {
            this.contactHoursModalVisible = true;
        },
        async submitHours() {
            this.isSavingHoursInfo = true;
            await axios
                .post("/api/schedule/updateAll", {
                    schedule: [
                        ...this.personalHoursArray,
                        ...this.getBusinessHours(),
                    ],
                })
                .then((response) => {
                    this.isSavingHoursInfo = false;
                    this.$toasted.global.toast_success("Save Successful");
                })
                .catch((error) => {
                    console.log(error);
                    alert("something went wrong!");
                });
        },
        updatedPersonalHours(personalHoursArray) {
            this.personalHoursArray = personalHoursArray;
        },
        getBusinessHours() {
            return this.user.schedule.filter((hoursDataItem) => {
                return hoursDataItem.usage == 1;
            });
        },
    },
    components: {
        Hours,
        ContactHoursTable,
    },
    computed: {
        isSaveButtonDisabled() {
            let result = false;
            this.personalHoursArray.forEach((personalHourItem) => {
                if (
                    personalHourItem.start_time == null ||
                    personalHourItem.end_time == null
                ) {
                    result = true;
                }
            });
            return result;
        },
    },
};
</script>

<style scoped>
::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    border-radius: 10px;
}

::-webkit-scrollbar-track {
    width: 10px;
    border-radius: 10px;
}
</style>
